import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemLookRoute: InvariantJiraRoute = {
	name: 'global-settings-system-look',
	path: '/secure/admin/LookAndFeel!default.jspa',
};
